import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#FF385C', contrastText: '#FFFFFF' },
    secondary: { main: '#D12D8C', contrastText: '#FFFFFF' },
    tertiary: { main: '#6A2BFF', contrastText: '#FFFFFF' },
    background: { default: '#FEFBFF', paper: '#FFFFFF' },
    text: { primary: '#1D1B20', secondary: '#49454F' },
  },
  typography: {
    fontFamily: "'Noto Sans JP', 'Roboto', sans-serif",
    button: { textTransform: 'none', fontWeight: 500 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 16, textTransform: 'none', fontWeight: 500 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 12, border: '1px solid #CAC4D0' },
      },
    },
  },
  brand: {
    gradient: 'linear-gradient(135deg, #FF385C 0%, #D12D8C 50%, #6A2BFF 100%)',
    platformGradient: 'linear-gradient(to right, #ffff00, #ff0000)',
    headerTextColor: '#000000',
  },
});
